/* global __APP_VERSION__ */
/**
 * Replay de sessão (LogRocket) no Admin — 17/09/2026.
 *
 * Quem INICIA o LogRocket é o agd.js (static.agendario.com.br, carregado no index.html com
 * data-app="admin"), uma vez para todos os apps, com rootHostname .agendario.com.br: a sessão
 * de quem chega pelo site, loga e faz o Welcome é UMA só. Só em produção (o agd.js decide pelo
 * hostname). Aqui entra o que só o Admin sabe:
 *  - o plugin React (filtrar sessões por componente clicado) — precisa de displayName nos componentes;
 *  - nome/e-mail do usuário logado (identify), a partir do JWT já decodificado pelo authService;
 *  - a versão do build (release).
 *
 * Tudo aqui é best-effort: o replay nunca pode derrubar o Admin.
 */
import setupLogRocketReact from 'logrocket-react';
import { authService } from '../services/authService';

let reactPluginReady = false;

function identificar() {
  try {
    const info = authService.getUserInfo?.();
    if (!info?.userId) return;
    const traits = {};
    if (info.name) traits.name = info.name;
    if (info.email) traits.email = info.email;
    window.AgndTrack?.setUser?.(String(info.userId), Object.keys(traits).length ? traits : undefined);
  } catch {
    /* replay nunca quebra o app */
  }
}

function ligarPluginReact() {
  if (reactPluginReady || !window.LogRocket) return;
  try {
    setupLogRocketReact(window.LogRocket);
    reactPluginReady = true;
  } catch {
    /* sem plugin, o replay continua funcionando */
  }
}

export function initializeSessionReplay() {
  try {
    // Release antes de o agd.js iniciar o SDK (o script é defer; este módulo roda antes).
    if (typeof __APP_VERSION__ !== 'undefined') window.AGND_RELEASE = `admin@${__APP_VERSION__}`;

    if (window.LogRocket?.__agndReady) {
      ligarPluginReact();
      identificar();
    } else {
      window.addEventListener('agnd:logrocket', () => { ligarPluginReact(); identificar(); }, { once: true });
    }
  } catch {
    /* idem */
  }
}

/** Chamado quando o token muda (login / retorno do Login com ?token=). */
export function sessionReplayUserChanged() {
  identificar();
}

/** Evento de negócio no replay (nome estável + propriedades simples). */
export function sessionReplayEvent(name, props) {
  try {
    window.AgndTrack?.event?.(name, props);
  } catch {
    /* idem */
  }
}
